import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function About() {
    return (

        <div className="inner-page about">

            <Header />

            <div className="rts-breadcrumb-area bg_image">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="baread-crumb-main-wrapper pt--100">
                                <div className="inner">
                                    <h1 className="title rts_hero__title">About Us</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="rts-about-area rts-section-gap mt--10">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="about-page-main-thumbnail-big-img-wrapper rts-reveal-to-bottom-wrapper">
                                <img className="rts-reveal-image-toBottom" src="assets/images/about/01.jpg" alt="about_large" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="our-approch-area-style-one rts-section-gap bg-dark-1">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="grid-lines-wrapper">
                                <div className="grid-lines">
                                    <div className="grid-line"></div>
                                    <div className="grid-line"></div>
                                    <div className="grid-line"></div>
                                    <div className="grid-line"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-7 col-md-6 rts-slide-right-gsap">

                            <div className="approch-area-left">
                                <div className="title-area-left-wrapper">
                                    <span className="pre-title">Our Story</span>
                                    <h2 className="title quote">The Partners in Your<br /> Digital Solutions</h2>
                                </div>
                                <p>
                                    Warmonks was born on a shared dream of a group of tech enthusiasts who came together<br /> to make use of the power of technology to create meaningful changes. Passion and a very<br /> clear vision did propel us and made our step toward building impactful digital solutions making<br /> life simplified and empowering a business to make the best out of it. For Warmonks, we always<br /> focused on the needs of the client. Their participation defined our journey. every collaborative<br /> success became part of our story. Their goals turned into our goals, and their wins became our<br /> proudest moments. With every project, we were getting closer to something greater, much bigger,<br /> with our expertise becoming more prolific than ever before. Now Warmonks is one of the best<br /> web development companies in Thrissur & the reason behind who we are now is our dedication, creativity, and commitment to innovation, Warmonks transformed from just a company into a<br /> trusted partner for businesses.
                                </p>

                            </div>

                        </div>
                        <div className="col-lg-5 col-md-6 rts-slide-left-gsap mt_sm--30">
                            <img src="./assets/images/about-us.gif" alt="" />
                        </div>
                    </div>
                </div>
                <div className="rts-two-boxes-section rts-section-gap mt--10">
                    <div className="container">
                        <div className="row">
                            {/* First Box */}
                            <div className="col-lg-6 col-md-6">
                                <div
                                    className="single-box-wrapper"
                                    style={{
                                        border: '2px solid #ccc',
                                        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                                        borderRadius: '8px',
                                        padding: '20px',
                                        backgroundColor: '#fff'
                                    }}
                                >
                                    <h3 className="box-title" style={{ color: 'black', textAlign: 'center' }}>Our Mission</h3>
                                    <p className="box-description">
                                        At Warmonks, our mission is to assist businesses and individuals
                                        with innovative, digital solutions for efficiency, growth, and measurable value.
                                    </p>
                                </div>
                            </div>

                            {/* Second Box */}
                            <div className="col-lg-6 col-md-6">
                                <div
                                    className="single-box-wrapper"
                                    style={{
                                        border: '2px solid #ccc',
                                        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                                        borderRadius: '8px',
                                        padding: '20px',
                                        backgroundColor: '#fff'
                                    }}
                                >
                                    <h3 className="box-title" style={{ color: 'black', textAlign: 'center' }}>Our Vision</h3>
                                    <p className="box-description">
                                        Our vision at Warmonks is to be the leader in web development and digital marketing, recognized for our creativity and commitment.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>


            <div className="progress-team-area rts-team__area rts-section-gap bg-dark-1 rts_jump_counter__animation">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="progress-ciurcle-wrapper-one">
                                <div className="counter_animation">

                                    <div className="single-progress-circle counter__anim">
                                        <svg className="radial-progress" data-countervalue="75" viewBox="0 0 80 80">
                                            <circle className="bar-static" cx="40" cy="40" r="35"></circle>
                                            <circle className="bar--animated" cx="40" cy="40" r="35"
                                                style={{ strokeDashoffset: '217.8' }}></circle>
                                            <text className="countervalue start" x="50%" y="56%"
                                                transform="matrix(0, 1, -1, 0, 80, 0)">75</text>
                                        </svg>
                                        <span className="small-text">
                                            Project Process
                                        </span>
                                    </div>

                                </div>
                                <div className="counter_animation">

                                    <div className="single-progress-circle counter__anim">
                                        <svg className="radial-progress" data-countervalue="95" viewBox="0 0 80 80">
                                            <circle className="bar-static" cx="40" cy="40" r="35"></circle>
                                            <circle className="bar--animated" cx="40" cy="40" r="35"
                                                style={{ strokeDashoffset: '217.8' }}></circle>
                                            <text className="countervalue start" x="50%" y="56%"
                                                transform="matrix(0, 1, -1, 0, 80, 0)">95</text>
                                        </svg>
                                        <span className="small-text">
                                            Branding Plans
                                        </span>
                                    </div>

                                </div>

                                <div className="counter_animation">

                                    <div className="single-progress-circle counter__anim">
                                        <svg className="radial-progress" data-countervalue="60" viewBox="0 0 80 80">
                                            <circle className="bar-static" cx="40" cy="40" r="35"></circle>
                                            <circle className="bar--animated" cx="40" cy="40" r="35"
                                                style={{ strokeDashoffset: '217.8' }}></circle>
                                            <text className="countervalue start" x="50%" y="56%"
                                                transform="matrix(0, 1, -1, 0, 80, 0)">60</text>
                                        </svg>
                                        <span className="small-text">
                                            Online Marketing
                                        </span>
                                    </div>

                                </div>

                                <div className="counter_animation">

                                    <div className="single-progress-circle counter__anim">
                                        <svg className="radial-progress" data-countervalue="83" viewBox="0 0 80 80">
                                            <circle className="bar-static" cx="40" cy="40" r="35"></circle>
                                            <circle className="bar--animated" cx="40" cy="40" r="35"
                                                style={{ strokeDashoffset: '217.8' }}></circle>
                                            <text className="countervalue start" x="50%" y="56%"
                                                transform="matrix(0, 1, -1, 0, 80, 0)">83</text>
                                        </svg>
                                        <span className="small-text">
                                            Concept Making
                                        </span>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="team-title-4">
                    <h2 className="title rts-has-mask-fill-2">Meet the professionals</h2>
                </div>
                <div className="container ">
                    <div className="row g-24">
                        <div className="col-lg-4 col-md-6 col-sm-6 col-12">

                            <div className="single-team-style-one rts-team__item">
                                <a href="#" className="thumbnail">
                                    <img src="assets/images/team/01.jpg" alt="team-image" />
                                </a>
                                <div className="inner-content">
                                    <span>Designer</span>
                                    <a href="#">
                                        <h5 className="name">Andrew D. Smith</h5>
                                    </a>
                                </div>
                            </div>

                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-6 col-12">

                            <div className="single-team-style-one rts-team__item">
                                <a href="#" className="thumbnail">
                                    <img src="assets/images/team/02.jpg" alt="team-image" />
                                </a>
                                <div className="inner-content">
                                    <span>Designer</span>
                                    <a href="#">
                                        <h5 className="name">Andrew D. Smith</h5>
                                    </a>
                                </div>
                            </div>

                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-6 col-12">

                            <div className="single-team-style-one rts-team__item">
                                <a href="#" className="thumbnail">
                                    <img src="assets/images/team/03.jpg" alt="team-image" />
                                </a>
                                <div className="inner-content">
                                    <span>Designer</span>
                                    <a href="#">
                                        <h5 className="name">Andrew D. Smith</h5>
                                    </a>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div className="rts-video-area-about rts-section-gap bg_image">

            </div>

            <div className="rtes-brand-area rts-section-gapBottom">

                <div className="container plr--60">
                    <div className="row rts-slide-left-gsap">
                        <div className="col-lg-12">

                            <div className="brand-main-wrapper-about">

                                <a href="#" className="single-brand">
                                    <img src="assets/images/brand/07.png" alt="brand" />
                                </a>

                                <a href="#" className="single-brand">
                                    <img src="assets/images/brand/08.png" alt="brand" />
                                </a>

                                <a href="#" className="single-brand">
                                    <img src="assets/images/brand/09.png" alt="brand" />
                                </a>

                                <a href="#" className="single-brand">
                                    <img src="assets/images/brand/10.png" alt="brand" />
                                </a>

                                <a href="#" className="single-brand">
                                    <img src="assets/images/brand/11.png" alt="brand" />
                                </a>

                                <a href="#" className="single-brand">
                                    <img src="assets/images/brand/12.png" alt="brand" />
                                </a>

                            </div>

                            <div className="brand-main-wrapper-about">

                                <a href="#" className="single-brand">
                                    <img src="assets/images/brand/13.png" alt="brand" />
                                </a>

                                <a href="#" className="single-brand">
                                    <img src="assets/images/brand/14.png" alt="brand" />
                                </a>

                                <a href="#" className="single-brand">
                                    <img src="assets/images/brand/15.png" alt="brand" />
                                </a>

                                <a href="#" className="single-brand">
                                    <img src="assets/images/brand/16.png" alt="brand" />
                                </a>

                                <a href="#" className="single-brand">
                                    <img src="assets/images/brand/17.png" alt="brand" />
                                </a>

                                <a href="#" className="single-brand">
                                    <img src="assets/images/brand/18.png" alt="brand" />
                                </a>

                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <Footer />

            <div className="loading-screen" id="loading-screen">
                <span className="bar top-bar"></span>
                <span className="bar down-bar"></span>
                <span className="progress-line"></span>
                <span className="loading-counter"> </span>
            </div>


            <div className="bg-noise"></div>

            <div className="progress-wrap">
                <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
                    <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"></path>
                </svg>
            </div>

            <div className="rts-cursor cursor-outer" data-default="yes" data-link="yes" data-slider="no">
                <span className="fn-cursor"></span>
            </div>
            <div className="rts-cursor cursor-inner" data-default="yes" data-link="yes" data-slider="no">
                <span className="fn-cursor">
                    <span className="fn-left"></span>
                    <span className="fn-right"></span>
                </span>
            </div>

            <div className="modal-sidebar-scroll rts-dark-light">
                <ul>
                    <li className="go-dark-w"><span>Dark</span><i className="rts-go-dark fal fa-moon"></i></li>
                    <li className="go-light-w"><span>Light</span><i className="rts-go-light fa-light fa-brightness"></i></li>
                </ul>
            </div>

        </div>
    )
}

export default About
